import * as React from 'react';

import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import type { PillsForScreenSize } from 'bundles/browse-common/components/Pill/PillGroup';

export const usePillScreenSize = (pillsForScreenSize: PillsForScreenSize) => {
  const isLg = useMediaQuery(breakpoints.up('lg'));
  const isMd = useMediaQuery(breakpoints.between('md', 'lg'));
  const isSm = useMediaQuery(breakpoints.between('sm', 'md'));

  const pillsToShow = React.useMemo(() => {
    if (isLg) return pillsForScreenSize.lg;
    if (isMd) return pillsForScreenSize.md;
    if (isSm) return pillsForScreenSize.sm;
    return pillsForScreenSize.xs;
  }, [pillsForScreenSize, isSm, isMd, isLg]);

  return { pillsToShow };
};
